import React, { useEffect, useRef, useState } from 'react';
// import myHeader from './Images/1.png';
import prof from '../Components/Images/pyrologo.png';
import '../Components/Header.css';
import blogo from "./Images/Bsnllogo.png";
import image1 from './Images/Channel Pay (1).png';
import channelpayimg from '../Components/Images/Channellogo.png'

function Header() {


  const [Hrms, setHrms] = useState("");
  const [Name, setName] = useState("");
  const [ShowPop, setShowPop] = useState(false);
  const submenuRef = useRef(null);
  const iconRef = useRef(null);
 
  const toggleArrow = () => setShowPop((prev) => !prev);
 
  const handleClickOutside = (event) => {
    if (
      submenuRef.current &&
      !submenuRef.current.contains(event.target) &&
      iconRef.current &&
      !iconRef.current.contains(event.target)
    ) {
      setShowPop(false);
    }
  };
 
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
 
  useEffect(() => {
    const hrmsid = localStorage.getItem("hrmsid");
    const HrmsId = hrmsid ? hrmsid.replace(/"/g, "") : "";
    setHrms(HrmsId);
 
    const firstName = localStorage.getItem("firstName");
    const FirstName = firstName ? firstName.replace(/"/g, "") : "";
    setName(FirstName);
  }, []);
 
  const username = localStorage.getItem("username");
  let username1 = '';
  if (username) {
    username1 = username.replace(/"/g, '');
    console.log(username1);
  }
 
//   const Logout = async () => {
//     const OPTIONS = {
//       method: 'GET',
//       headers: { 'Content-Type': 'application/json' },
//     };
 
//     try {
//       const response = await fetch(`${Userurl}/ctopup-user-api/scmlogout?username=${username1}`, OPTIONS);
//       const data = await response.json();
 
//     if (data.status === 200) {
//         localStorage.clear();
//         sessionStorage.clear();
//         window.location.replace('/'); // Use replace for clean redirect
//       } else if (data.status === 404) {
//         console.error("Logout failed: User not found");
//       }
//     } catch (error) {
//       console.error("Error logging out:", error);
//     }
//   };
 
  return (
<div className='header-sticky'>
  <div className='container-fluid'>
    <div className="top-image d-flex justify-content-between align-items-center w-100">

      {/* Desktop Logo */}
      <img 
        className="d-none d-md-block image" 
        src={image1} 
        alt="Logo" 
      />

      {/* Mobile Only Logo */}
      <img 
        className="d-block d-md-none mx-auto" 
        src={channelpayimg} 
        alt="Logo" 
      />

      {/* Profile - Desktop Only */}
      <div className="username d-none d-md-flex align-items-center">
        <img className="proflogo" src={prof} alt="Profile logo"/>
      </div>

    </div>
  </div>
</div>
  );
}
 
export default Header;